import { render, staticRenderFns } from "./ChangeStatus.vue?vue&type=template&id=cf45d3b4&scoped=true"
import script from "./ChangeStatus.vue?vue&type=script&lang=js"
export * from "./ChangeStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf45d3b4",
  null
  
)

export default component.exports